import { render, staticRenderFns } from "./SubsitutionStatusBadge.vue?vue&type=template&id=07a1373b"
import script from "./SubsitutionStatusBadge.vue?vue&type=script&lang=js"
export * from "./SubsitutionStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports